var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$_onClicked()}}},'v-btn',_vm.$attrs,false),[_c('v-icon',[_vm._v("mdi-play-box")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }